import { render } from "./ContractsComponent.vue?vue&type=template&id=09e7616e"
import script from "./ContractsComponent.vue?vue&type=script&lang=js"
export * from "./ContractsComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__